var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('img',{staticClass:"balsa-file-image",attrs:{"src":_vm.getImgUrl(_vm.icon),"alt":"balsa"}})])}
var staticRenderFns = []

export { render, staticRenderFns }